import { SoundEntity } from './SoundEntity';

export class Selection {
    constructor(public entity: SoundEntity, public state: String) {

    }
}